













import { Vue, Component } from 'vue-property-decorator';
import { Loading, Toast } from 'vant';
import { judgeDate } from '../utils/check';

Vue.use(Loading);

@Component
export default class Index extends Vue {
  loading: boolean = true;

  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  handleClickUpload(val: string) {
    const date = '2020/06/10 08:00';

    const val1 = new Date(date).getTime();
    const val2 = new Date().getTime();

    if (judgeDate(val1, val2)) {
      Toast('活动未开始');
      return;
    }

    this.$router.push({
      path: val,
    });
  }
}
